import { render, staticRenderFns } from "./pensionAction.vue?vue&type=template&id=6628b9d6"
import script from "./pensionAction.vue?vue&type=script&lang=js"
export * from "./pensionAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports